import { LORAX } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error untyped dependency
import { HR } from 'UIComponents/elements';
import { H7 } from 'UIComponents/elements/headings';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIImage from 'UIComponents/image/UIImage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AppReviewWizardHeader({
  appIconUrl,
  appName
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: "m-x-5",
    children: [/*#__PURE__*/_jsxs(UIGrid, {
      className: "p-top-6 p-bottom-2",
      children: [/*#__PURE__*/_jsx(UIGridItem, {
        size: {
          xs: 0,
          md: 1,
          lg: 3
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.detail.reviews.wizard.write"
        })
      }), /*#__PURE__*/_jsx(UIGridItem, {
        size: {
          xs: 12,
          md: 10,
          lg: 6
        },
        children: /*#__PURE__*/_jsxs(UIFlex, {
          className: "width-100",
          direction: "row",
          align: "center",
          justify: "center",
          children: [/*#__PURE__*/_jsx(UIMediaObject, {
            align: "center",
            itemLeft: /*#__PURE__*/_jsx(UIImage, {
              alt: appName,
              "data-test-id": "app-wizard-header-image",
              src: appIconUrl,
              width: 40
            }),
            children: /*#__PURE__*/_jsx(H7, {
              className: "m-all-0",
              children: appName
            })
          }), /*#__PURE__*/_jsx(H7, {
            className: "m-x-2 m-y-0",
            children: "+"
          }), /*#__PURE__*/_jsx(UIMediaObject, {
            align: "center",
            itemLeft: /*#__PURE__*/_jsx(UIIcon, {
              name: "sprocket",
              color: LORAX,
              size: 40
            }),
            children: /*#__PURE__*/_jsx(H7, {
              className: "m-all-0",
              children: "HubSpot"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(UIGridItem, {
        size: {
          xs: 0,
          md: 1,
          lg: 3
        }
      })]
    }), /*#__PURE__*/_jsx(HR, {
      distance: "flush"
    })]
  });
}